module.exports = __webpack_public_path__ + "static/img/icon-p1-3gs.d538f6e6.png";